// 处理人群包值转字符串
import { isArray, isEmpty, getKeyOfData, deepCopy } from '@/common/js/utils'
// import { DAYS } from '@/views/create/tencent_local/components/actioninterest/data'
import { DAYS as FAYS, BEHAVIORS } from '@/views/create/toutiao_local/components/awemeaction/data'
import { ad_convert } from '@/data/tencent/ad_target_data'

const DAYS = [
  {
    key: 'BEHAVIOR_INTEREST_TIME_WINDOW_SEVEN_DAY',
    label: '7 天'
  },
  {
    key: 'BEHAVIOR_INTEREST_TIME_WINDOW_FIFTEEN_DAY',
    label: '15 天'
  },
  {
    key: 'BEHAVIOR_INTEREST_TIME_WINDOW_THIRTY_DAY',
    label: '30 天'
  },
  {
    key: 'BEHAVIOR_INTEREST_TIME_WINDOW_THREE_MONTH',
    label: '3 个月'
  },
  {
    key: 'BEHAVIOR_INTEREST_TIME_WINDOW_SIX_MONTH',
    label: '6 个月'
  },
  {
    key: 'BEHAVIOR_INTEREST_TIME_WINDOW_ONE_YEAR',
    label: '1 年'
  }
]

export function deCompile(ret, orignData) {
  const { articleData, brandData, cityData, tagsData, gategoryData, autotendData } = orignData
  const includeItem = { key: 'includes', name: '定向人群包' }
  const excludeItem = { key: 'excludes', name: '排除人群包' }
  const cityItem = { key: 'city', name: '地域' }
  const genderItem = { key: 'gender', name: '性别' }
  const ageItem = { key: 'age', name: '年龄' }
  const actionInterestItem = { key: 'interest_action_mode', name: '行为兴趣定向' }
  const actionSceneItem = { key: 'action_scene', name: '行为场景' }
  const actionDaysItem = { key: 'action_days', name: '行为天数' }
  const actionCatesItem = { key: 'action_tags', name: '行为分类' }
  const actionWordsItem = { key: 'action_tags', name: '行为关键词' }
  const interestCatesItem = { key: 'interest_tags', name: '兴趣分类' }
  const interestWordsItem = { key: 'interest_tags', name: '兴趣关键词' }
  const tagsItem = { key: 'tags', name: '兴趣定向' }
  const adTagItem = { key: 'ad_tag', name: '兴趣分类' }
  const superPopularItem = { key: 'superior_popularity_type', name: '穿山甲媒体定向' }
  const mediaIncludeItem = { key: 'media_includes', name: '定向穿山甲流量包' }
  const mediaExcludeItem = { key: 'media_excludes', name: '排除穿山甲流量包' }
  const platformItem = { key: 'platform', name: '平台' }
  const acItem = { key: 'ac', name: '网络' }
  const carrierItem = { key: 'carrier', name: '运营商' }
  const acitvateItem = { key: 'activate_type', name: '新用户' }
  const appCategroyItem = { key: 'app_category', name: 'APP行为' }
  const brandItem = { key: 'brand', name: '手机品牌' }
  const priceItem = { key: 'launch_price', name: '手机价格' }
  const androidOsvItem = { key: 'android_osv', name: '安卓版本' }
  const iosOsvItem = { key: 'ios_osv', name: 'iOS版本' }
  const deviceItem = { key: 'device_type', name: '设备类型' }
  const articleCategroyItem = { key: 'article_category', name: '文章分类' }
  const autotendItem = { key: 'auto_extend_targets', name: '智能放量' }
  const hideconvertedItem = { key: 'hide_if_converted', name: '过滤已转化' }
  const fanAwemeItem = { key: 'aweme_talents', name: '抖音达人定向' }
  const fanSceneItem = { key: 'aweme_fan_behaviors', name: '粉丝互动场景' }
  const fanDaysItem = { key: 'aweme_fan_time_scope', name: '粉丝互动天数' }
  const fanCatesItem = { key: 'fan_tags', name: '达人分类' }
  const fanWordsItem = { key: 'fan_tags', name: '抖音达人' }
  const awemeCountItem = { key: 'filter_aweme_fans_count', name: '过滤高关注' }
  const awemeActiveItem = { key: 'filter_aweme_abnormal_active', name: '过滤高活跃' }
  const awemeOwnItem = { key: 'filter_own_aweme_fans', name: '过滤粉丝' }
  // 根据id查名称
  const getNameByKey = (ids, data, key) => {
    return ids.map((ret) => {
      const { value } = getKeyOfData(data, key, ret)
      return value
    })
  }
  const getBehavior = (val) => {
    const { title } = getKeyOfData(BEHAVIORS, 'key', val)
    return title
  }
  const getFanTime = (val) => {
    const { value } = FAYS.filter((ret) => ret.key === val).pop()
    return value
  }
  if (isArray(ret.includes) && ret.includes.length) includeItem.values = ret.includes.map((ret) => ret && ret.name)
  else includeItem.hide = true
  if (isArray(ret.excludes) && ret.excludes.length) excludeItem.values = ret.excludes.map((ret) => ret && ret.name)
  else excludeItem.hide = true
  if (isArray(ret.city) && ret.city.length) cityItem.values = getNameByKey(ret.city, cityData, 'id')
  else cityItem.hide = true
  if (ret.gender !== 'NONE') genderItem.values = ret.gender === 'GENDER_FEMALE' ? '女' : '男'
  else genderItem.all = true
  if (isArray(ret.age) && ret.age.length) {
    ageItem.values = ret.age.map((met) => {
      if (met === 'AGE_BELOW_18') met = '小于18岁'
      if (met === 'AGE_BETWEEN_18_23') met = '18-23岁'
      if (met === 'AGE_BETWEEN_24_30') met = '24-30岁'
      if (met === 'AGE_BETWEEN_31_40') met = '31-40岁'
      if (met === 'AGE_BETWEEN_41_49') met = '41-49岁'
      if (met === 'AGE_ABOVE_50') met = '大于等于50岁'
      return met
    })
  } else ageItem.all = true
  // 新版定向
  const isAction = isArray(ret.action_tags) && ret.action_tags.length
  const isInterest = isArray(ret.word_tags) && ret.word_tags.length
  if (ret.interest_action_mode === 'UNLIMITED') {
    actionInterestItem.all = true
    actionCatesItem.hide = true
    actionWordsItem.hide = true
    interestCatesItem.hide = true
    interestWordsItem.hide = true
    actionSceneItem.hide = true
    actionDaysItem.hide = true
  } else if (ret.interest_action_mode === 'RECOMMEND') {
    actionInterestItem.values = ['系统推荐']
    actionCatesItem.hide = true
    actionWordsItem.hide = true
    interestCatesItem.hide = true
    interestWordsItem.hide = true
    actionSceneItem.hide = true
    actionDaysItem.hide = true
  } else if (isAction || isInterest) {
    actionInterestItem.values = ['自定义']
    if (isAction) {
      actionSceneItem.values =
        isArray(ret.action_scene) && ret.action_scene.length
          ? ret.action_scene.map((met) => {
            if (met === 'E-COMMERCE') met = '电商互动行为'
            if (met === 'NEWS') met = '资讯互动行为'
            if (met === 'APP') met = 'APP推广互动行为'
            return met
          })
          : ['电商互动行为', '资讯互动行为', 'APP推广互动行为']
      actionDaysItem.values = [`${ret.action_days}天`]
      const categories = ret.action_tags.filter((met) => met.type.toLowerCase() === 'category').map((met) => met.name)
      if (categories.length) actionCatesItem.values = categories
      else actionCatesItem.hide = true
      const keywords = ret.action_tags.filter((met) => met.type.toLowerCase() === 'keyword').map((met) => met.name)
      if (keywords.length) actionWordsItem.values = keywords
      else actionWordsItem.hide = true
    } else {
      actionCatesItem.hide = true
      actionWordsItem.hide = true
    }
    if (isInterest) {
      const categories = ret.word_tags.filter((met) => met.type.toLowerCase() === 'category').map((met) => met.name)
      if (categories.length) interestCatesItem.values = categories
      else interestCatesItem.hide = true
      const keywords = ret.word_tags.filter((met) => met.type.toLowerCase() === 'keyword').map((met) => met.name)
      if (keywords.length) interestWordsItem.values = keywords
      else interestWordsItem.hide = true
    } else {
      interestCatesItem.hide = true
      interestWordsItem.hide = true
    }
  }
  if (isEmpty(ret.tags) && ret.tags !== 'NONE') tagsItem.values = ret.tags === 'REFEREE' ? ['系统推荐'] : ['自定义']
  else tagsItem.all = true
  if (isArray(ret.ad_tag) && ret.ad_tag.length) adTagItem.values = getNameByKey(ret.ad_tag, tagsData, 'id')
  else adTagItem.all = true
  if (!isEmpty(ret.superior_popularity_type) && ret.superior_popularity_type !== 'NONE') {
    superPopularItem.values = ['GAME', 'APP'].includes(ret.superior_popularity_type)
      ? ret.superior_popularity_type === 'GAME'
        ? ['游戏优质媒体']
        : ['应用软件精选']
      : ['自定义']
  } else superPopularItem.all = true
  if (isArray(ret.media_includes) && ret.media_includes.length) mediaIncludeItem.values = ret.media_includes.map((ret) => ret && ret.name)
  else mediaIncludeItem.hide = true
  if (isArray(ret.media_excludes) && ret.media_excludes.length) mediaExcludeItem.values = ret.media_excludes.map((ret) => ret && ret.name)
  else mediaExcludeItem.hide = true
  if (isArray(ret.platform) && ret.platform.length) {
    platformItem.values = ret.platform.map((met) => {
      if (met === 'ANDROID') met = 'Android'
      if (met === 'IOS') met = 'iOS'
      return met
    })
  } else platformItem.all = true
  if (!(isArray(ret.platform) && ret.platform.includes('ANDROID'))) androidOsvItem.hide = true
  else if (ret.android_osv === '0.0' || ret.android_osv === 'NONE') androidOsvItem.all = true
  else androidOsvItem.values = [`Android ${ret.android_osv}及以上`]
  if (!(isArray(ret.platform) && ret.platform.includes('IOS'))) iosOsvItem.hide = true
  else if (ret.ios_osv === '0.0' || ret.ios_osv === 'NONE') iosOsvItem.all = true
  else iosOsvItem.values = [`iOS ${ret.ios_osv}及以上`]
  if (isArray(ret.device_type) && ret.device_type.length) {
    deviceItem.values = ret.device_type.map((met) => {
      if (met === 'MOBILE') met = '智能手机'
      if (met === 'PAD') met = '平板'
      return met
    })
  } else deviceItem.all = true
  if (isArray(ret.ac) && ret.ac.length) {
    acItem.values = ret.ac.map((met) => {
      if (met === 'WIFI') met = 'WIFI'
      if (met === '2G') met = '2G'
      if (met === '3G') met = '3G'
      if (met === '4G') met = '4G'
      return met
    })
  } else acItem.all = true
  if (isArray(ret.carrier) && ret.carrier.length) {
    carrierItem.values = ret.carrier.map((met) => {
      if (met === 'MOBILE') met = '移动'
      if (met === 'UNICOM') met = '联通'
      if (met === 'TELCOM') met = '电信'
      return met
    })
  } else carrierItem.all = true
  if (isArray(ret.activate_type) && ret.activate_type.length) {
    acitvateItem.values = ret.activate_type.map((met) => {
      if (met === 'WITH_IN_A_MONTH') met = '一个月以内'
      if (met === 'ONE_MONTH_2_THREE_MONTH') met = '一个月到三个月'
      if (met === 'THREE_MONTH_EAILIER') met = '三个月或更早'
      return met
    })
  } else acitvateItem.all = true
  if (isArray(ret.app_category) && ret.app_category.length) appCategroyItem.values = getNameByKey(ret.app_category, gategoryData, 'id')
  else if (isArray(ret.platform) && ret.platform.includes('ANDROID')) appCategroyItem.all = true
  else appCategroyItem.hide = true
  if (isArray(ret.device_brand) && ret.device_brand.length) brandItem.values = getNameByKey(ret.device_brand, brandData, 'key')
  else if (isArray(ret.platform) && ret.platform.includes('ANDROID')) brandItem.all = true
  else brandItem.hide = true
  if (isEmpty(ret.launch_price)) priceItem.hide = true
  else if (isArray(ret.launch_price) && ret.launch_price.length) {
    const [min, max] = ret.launch_price
    if (min === 0 && max === 11000) priceItem.all = true
    else if (min === 0) priceItem.values = [`${max}元以内`]
    else if (max === 11000) priceItem.values = [`${min}元以上`]
    else priceItem.values = [`${min}元-${max}元`]
  } else priceItem.all = true
  if (isArray(ret.article_category) && ret.article_category.length) {
    articleCategroyItem.values = getNameByKey(ret.article_category, articleData, 'key')
  } else articleCategroyItem.all = true
  if (!ret.auto_extend_enabled) autotendItem.values = ['不启用']
  else if (isArray(ret.auto_extend_targets) && ret.auto_extend_targets.length) {
    autotendItem.values = getNameByKey(ret.auto_extend_targets, autotendData, 'key')
  } else autotendItem.hide = true
  if (ret.hide_if_converted) {
    const hideConvertedFilter = (met) => {
      if (met === 'AD') return ['计划']
      else if (met === 'CAMPAIGN') return ['计划组']
      else if (met === 'ADVERTISER') return ['计划账户']
      else if (met === 'APP') return ['APP']
      else if (met === 'CUSTOMER') return ['公司账户']
      else return ['不过滤']
    }
    hideconvertedItem.values = hideConvertedFilter(ret.hide_if_converted)
  } else hideconvertedItem.hide = true
  if (typeof ret.filter_aweme_abnormal_active === 'number') {
    // ret.filter_aweme_abnormal_active 区分直播定向
    awemeCountItem.values = ret.filter_aweme_fans_count ? [`> ${ret.filter_aweme_fans_count}`] : ['不过滤']
    awemeActiveItem.values = ret.filter_aweme_abnormal_active ? ['过滤'] : ['不过滤']
    awemeOwnItem.values = ret.filter_own_aweme_fans ? ['过滤'] : ['不过滤']
    if (
      (ret.aweme_talents === 'CUSTOM' || typeof ret.filter_aweme_abnormal_active === 'number') &&
      isArray(ret.fan_tags) &&
      ret.fan_tags.length
    ) {
      const categories = ret.fan_tags.filter((met) => met.type.toLowerCase() === 'category').map((met) => met.name)
      const keywords = ret.fan_tags.filter((met) => met.type.toLowerCase() === 'keyword').map((met) => met.name)
      if (categories.length) fanCatesItem.values = categories
      else fanCatesItem.hide = true
      if (keywords.length) fanWordsItem.values = keywords
      else fanWordsItem.hide = true
      fanSceneItem.values =
        isArray(ret.aweme_fan_behaviors) && ret.aweme_fan_behaviors.length ? ret.aweme_fan_behaviors.map((met) => getBehavior(met)) : []
      fanDaysItem.values = [getFanTime(ret.aweme_fan_time_scope)]
      fanAwemeItem.values = ['自定义']
    } else {
      fanAwemeItem.values = ['不限']
      fanCatesItem.hide = true
      fanWordsItem.hide = true
      fanSceneItem.hide = true
      fanDaysItem.hide = true
    }
  } else {
    fanAwemeItem.hide = true
    fanSceneItem.hide = true
    fanDaysItem.hide = true
    fanCatesItem.hide = true
    fanWordsItem.hide = true
    awemeCountItem.hide = true
    awemeActiveItem.hide = true
    awemeOwnItem.hide = true
  }

  return [
    includeItem,
    excludeItem,
    cityItem,
    genderItem,
    ageItem,
    actionInterestItem,
    actionSceneItem,
    actionDaysItem,
    actionCatesItem,
    actionWordsItem,
    interestCatesItem,
    interestWordsItem,
    superPopularItem,
    mediaIncludeItem,
    mediaExcludeItem,
    platformItem,
    acItem,
    carrierItem,
    acitvateItem,
    appCategroyItem,
    brandItem,
    priceItem,
    androidOsvItem,
    iosOsvItem,
    hideconvertedItem,
    deviceItem,
    articleCategroyItem,
    autotendItem,
    fanAwemeItem,
    fanSceneItem,
    fanDaysItem,
    fanCatesItem,
    fanWordsItem,
    awemeCountItem,
    awemeActiveItem,
    awemeOwnItem
  ]
}
// 根据id查名称
const getNameByKey = (ids, data, key) => {
  return ids.map((ret) => {
    const { value } = getKeyOfData(data, key, ret)
    return value
  })
}
export function teCompile(ret, orignData) {
  if (isEmpty(ret.district)) {
    // 参数不存在为系统定向
    ret = convertSystemTarget(ret)
  }
  const { brandData, cityData, mobileMediaTypeData, intentData, versionData, wechatAdBehavior } = orignData
  const includeItem = { key: 'includes', name: '定向人群包' }
  const excludeItem = { key: 'excludes', name: '排除人群包' }
  const cityItem = { key: 'city', name: '地域' }
  const locationTypesItem = { key: 'location_types', name: '地域类型' }
  const genderItem = { key: 'gender', name: '性别' }
  const ageItem = { key: 'age', name: '年龄' }
  const actionInterestItem = { key: 'interest_action_mode', name: '行为兴趣定向' }
  const actionSceneItem = { key: 'action_scene', name: '行为场景' }
  const actionDaysItem = { key: 'action_days', name: '行为天数' }
  const actionIntensityItem = { key: 'action_days', name: '行为强度' }
  const actionCatesItem = { key: 'action_tags', name: '行为分类' }
  const actionWordsItem = { key: 'action_tags', name: '行为关键词' }
  const interestCatesItem = { key: 'interest_tags', name: '兴趣分类' }
  const interestWordsItem = { key: 'interest_tags', name: '兴趣关键词' }
  const intentionTagsItem = { key: 'tags', name: '意向关键词' }
  const brandItem = { key: 'brand', name: '手机品牌' }
  const osItem = { key: 'user_os', name: '系统版本' }
  const networkTypeItem = { key: 'network_type', name: '网络' }
  const carrierItem = { key: 'carrier', name: '运营商' }
  const newDeviceItem = { key: 'new_device', name: '新设备用户' }
  const gamePayLevelItem = { key: 'gamePayLevel', name: '游戏消费能力' }
  const priceItem = { key: 'device_price', name: '设备价格' }
  const appInstallItem = { key: 'app_install_status', name: '应用安装' }
  const autotendItem = { key: 'auto_extend_targets', name: '自动扩量' }
  const unOverTargetItem = { key: 'un_over_target', name: '不可突破定向' }
  const coldStartAudienceItem = { key: 'cold_start_audience', name: '扩量种子人群包' }
  const hideConvertedItem = { key: 'hide_if_converted', name: '过滤已转化' }
  const customConvertedItem = { key: 'custom_converted', name: '自定义转化行为' }
  const mobileMediaTypeItem = { key: 'mobile_media_type', name: '移动媒体类型' }
  const wechatAdActionsItem = { key: 'actions', name: '微信再营销包含' }
  const wechatAdExcludesActionsItem = { key: 'excluded_actions', name: '微信再营销排除' }

  const { regions, location_types } = ret.geo_location || {}
  if (isArray(ret.includes) && ret.includes.length) includeItem.values = ret.includes.map((ret) => ret && ret.name)
  else includeItem.hide = true
  if (isArray(ret.excludes) && ret.excludes.length) excludeItem.values = ret.excludes.map((ret) => ret && ret.name)
  else excludeItem.hide = true
  if (isArray(regions) && regions.length) {
    cityItem.values = getNameByKey(regions, cityData, 'id')
    locationTypesItem.values = location_types.map((met) => {
      if (met === 'RECENTLY_IN') met = '近期在这里的人'
      if (met === 'LIVE_IN') met = '常住这里的人'
      if (met === 'TRAVEL_IN') met = '旅行到这里的人'
      if (met === 'VISITED_IN') met = '去过这里的人'
      return met
    })
  } else {
    cityItem.all = true
    locationTypesItem.hide = true
  }
  if (isArray(ret.gender) && ret.gender.length) genderItem.values = ret.gender[0] === 'FEMALE' ? ['女'] : ['男']
  else if (ret.gender && ret.gender !== 'NONE') genderItem.values = ret.gender === 'FEMALE' ? ['女'] : ['男']
  else genderItem.all = true
  if (isArray(ret.age) && ret.age.length) {
    if (typeof ret.age[0] === 'number') ageItem.values = [`${ret.age[0]}~${ret.age[1]}`]
    else ageItem.values = [`${ret.age[0].min}~${ret.age[0].max}`]
  } else ageItem.all = true
  // 新版定向
  const { intention } = ret.behavior_or_interest || {}
  const isAction = isArray(ret.action_tags) && ret.action_tags.length
  const isInterest = isArray(ret.word_tags) && ret.word_tags.length
  const isIntention = !isEmpty(intention)
  if (ret.interest_action_mode === 'UNLIMITED') {
    actionInterestItem.all = true
    actionCatesItem.hide = true
    actionWordsItem.hide = true
    interestCatesItem.hide = true
    interestWordsItem.hide = true
    actionSceneItem.hide = true
    actionDaysItem.hide = true
    intentionTagsItem.hide = true
    actionIntensityItem.hide = true
  } else if (ret.interest_action_mode === 'RECOMMEND') {
    actionInterestItem.values = ['系统优选']
    actionCatesItem.hide = true
    actionWordsItem.hide = true
    interestCatesItem.hide = true
    interestWordsItem.hide = true
    actionSceneItem.hide = true
    actionDaysItem.hide = true
    intentionTagsItem.hide = true
    actionIntensityItem.hide = true
  } else if (isAction || isInterest || isIntention) {
    actionInterestItem.values = ['自定义']
    if (isAction) {
      actionSceneItem.values =
        isArray(ret.action_scene) && ret.action_scene.length
          ? ret.action_scene.map((met) => {
            if (met === 'BEHAVIOR_INTEREST_SCENE_ALL') met = '不限'
            if (met === 'BEHAVIOR_INTEREST_SCENE_APP') met = 'APP'
            if (met === 'BEHAVIOR_INTEREST_SCENE_ECOMMERCE') met = '电商'
            if (met === 'BEHAVIOR_INTEREST_SCENE_INFORMATION') met = '资讯'
            return met
          })
          : ['APP', '电商', '资讯']
      actionDaysItem.values = DAYS.filter((d) => d.key === ret.action_days).map((m) => m.label)
      actionIntensityItem.values = ret.action_intensity.map((met) => {
        if (met === 'BEHAVIOR_INTEREST_INTENSITY_ALL') met = '不限'
        if (met === 'BEHAVIOR_INTEREST_INTENSITY_HIGH') met = '高强度'
        return met
      })
      const categories = ret.action_tags.filter((met) => met.type.toLowerCase() === 'category').map((met) => met.name)
      if (categories.length) actionCatesItem.values = categories
      else actionCatesItem.hide = true
      const keywords = ret.action_tags.filter((met) => met.type.toLowerCase() === 'keyword').map((met) => met.name)
      if (keywords.length) actionWordsItem.values = keywords
      else actionWordsItem.hide = true
    } else {
      actionCatesItem.hide = true
      actionWordsItem.hide = true
      actionSceneItem.hide = true
      actionDaysItem.hide = true
      actionIntensityItem.hide = true
    }
    if (isInterest) {
      const categories = ret.word_tags.filter((met) => met.type.toLowerCase() === 'category').map((met) => met.name)
      if (categories.length) interestCatesItem.values = categories
      else interestCatesItem.hide = true
      const keywords = ret.word_tags.filter((met) => met.type.toLowerCase() === 'keyword').map((met) => met.name)
      if (keywords.length) interestWordsItem.values = keywords
      else interestWordsItem.hide = true
    } else {
      interestCatesItem.hide = true
      interestWordsItem.hide = true
    }
    if (isIntention) {
      const { targeting_tags } = ret.behavior_or_interest.intention
      if (targeting_tags.length) intentionTagsItem.values = getNameByKey(targeting_tags, intentData, 'key')
      else intentionTagsItem.hide = true
    } else intentionTagsItem.hide = true
  }
  // 手机品牌
  const { included_list, excluded_list } = ret.device_brand_model || {}
  if (!ret.device_brand_model) brandItem.all = true
  else if (isArray(included_list) && included_list.length) brandItem.values = getNameByKey(included_list, brandData, 'key')
  else if (isArray(excluded_list) && excluded_list.length) {
    brandItem.name = '手机品牌(排除)'
    brandItem.values = getNameByKey(excluded_list, brandData, 'key')
  } else brandItem.all = true
  // 系统版本
  if (isArray(ret.user_os) && ret.user_os.length) {
    osItem.values = getNameByKey(ret.user_os, versionData, 'key')
  } else osItem.all = true
  // 网络
  if (isArray(ret.network_type) && ret.network_type.length) {
    networkTypeItem.values = ret.network_type.map((met) => {
      if (met === 'WIFI') met = 'WIFI'
      if (met === 'NET_2G') met = '2G'
      if (met === 'NET_3G') met = '3G'
      if (met === 'NET_4G') met = '4G'
      return met
    })
  } else networkTypeItem.all = true
  // 运营商
  if (isArray(ret.network_operator) && ret.network_operator.length) {
    carrierItem.values = ret.network_operator.map((met) => {
      if (met === 'CMCC') met = '移动'
      if (met === 'CUC') met = '联通'
      if (met === 'CTC') met = '电信'
      return met
    })
  } else carrierItem.all = true
  // 新设备用户
  if (isArray(ret.new_device) && ret.new_device.length) {
    newDeviceItem.values = ret.new_device.map((met) => {
      if (met === 'IOS') met = '苹果新用户'
      if (met === 'ANDROID') met = '安卓新用户'
      return met
    })
  } else newDeviceItem.all = true
  // 游戏消费能力
  if (isArray(ret.game_consumption_level) && ret.game_consumption_level.length) {
    gamePayLevelItem.values = ret.game_consumption_level.map((met) => {
      if (met === 'HIGH') met = '高'
      if (met === 'NORMAL') met = '普通'
      return met
    })
  } else gamePayLevelItem.all = true
  // 设备价格
  if (isArray(ret.device_price) && ret.device_price.length) {
    priceItem.values = ret.device_price.map((met) => {
      if (met === 'PRICE_4500_MORE') met = '4500元以上'
      if (met === 'PRICE_3500_4500') met = '3500~4500元'
      if (met === 'PRICE_2500_3500') met = '2500~3500元'
      if (met === 'PRICE_1500_2500') met = '1500~2500元'
      if (met === 'PRICE_1500_LESS') met = '1500元以下'
      return met
    })
  } else priceItem.all = true
  // 应用安装
  if (ret.app_install_status && ret.app_install_status !== 'NONE') {
    if (isArray(ret.app_install_status)) {
      appInstallItem.values = ret.app_install_status[0] === 'NOT_INSTALLED' ? ['未安装该应用用户'] : ['已安装该应用用户']
    } else appInstallItem.values = ret.app_install_status === 'NOT_INSTALLED' ? ['未安装该应用用户'] : ['已安装该应用用户']
  } else appInstallItem.all = true
  // 自动扩量
  if (ret.expand_enabled) {
    autotendItem.values = ['开启']
    if (isArray(ret.expand_targeting)) {
      unOverTargetItem.values = ret.expand_targeting.map((met) => {
        if (met === 'geo_location') met = '地域'
        if (met === 'age') met = '年龄'
        if (met === 'gender') met = '性别'
        return met
      })
    } else unOverTargetItem.all = true
    if (isArray(ret.mult_cold)) {
      coldStartAudienceItem.values = ret.mult_cold.map((met) => met && met.value)
    }
  } else {
    autotendItem.values = ['关闭']
    unOverTargetItem.hide = true
    coldStartAudienceItem.hide = true
  }
  // 排除已转化
  const { excluded_dimension, conversion_behavior_list } = ret.excluded_converted_audience || {}
  if (excluded_dimension === 'EXCLUDED_DIMENSION_CAMPAIGN') hideConvertedItem.values = ['同计划']
  else if (excluded_dimension === 'EXCLUDED_DIMENSION_UID') hideConvertedItem.values = ['同账号计划']
  else if (excluded_dimension === 'EXCLUDED_DIMENSION_BUSINESS_MANAGER') hideConvertedItem.values = ['同商务管家计划']
  else if (excluded_dimension === 'EXCLUDED_DIMENSION_COMPANY_ACCOUNT') hideConvertedItem.values = ['同主体计划']
  else if (excluded_dimension === 'EXCLUDED_DIMENSION_APP') hideConvertedItem.values = ['同应用']
  else hideConvertedItem.all = true
  if (typeof ret.custom_convert !== 'undefined') {
    if (ret.custom_convert && isArray(ad_convert)) {
      const convert = ad_convert.filter((met) => met.value === conversion_behavior_list).pop() || { label: '未知' }
      customConvertedItem.values = [convert.label]
    } else customConvertedItem.hide = true
  } else {
    if (isArray(conversion_behavior_list) && isArray(ad_convert) && conversion_behavior_list.length) {
      const convert = ad_convert.filter((met) => met.value === conversion_behavior_list[0]).pop() || { label: '未知' }
      customConvertedItem.values = [convert.label]
    } else customConvertedItem.hide = true
  }
  // 移动媒体类型
  if (isArray(ret.mobile_union_category) && ret.mobile_union_category.length) {
    mobileMediaTypeItem.values = getNameByKey(ret.mobile_union_category, mobileMediaTypeData, 'key')
  } else if (ret.mobile_media_type === 'NONE') mobileMediaTypeItem.all = true
  else mobileMediaTypeItem.hide = true

  // 微信再营销
  if (ret.wechat_ad_behavior) {
    const { actions, excluded_actions } = ret.wechat_ad_behavior
    if (isArray(actions)) {
      wechatAdActionsItem.values = wechatAdBehavior.filter((s) => actions.includes(s.value)).map((s) => s.label)
    } else {
      wechatAdActionsItem.all = true
    }
    if (isArray(excluded_actions)) {
      wechatAdExcludesActionsItem.values = wechatAdBehavior.filter((s) => excluded_actions.includes(s.value)).map((s) => s.label)
    } else {
      wechatAdExcludesActionsItem.all = true
    }
  } else {
    wechatAdActionsItem.hide = true
    wechatAdExcludesActionsItem.hide = true
  }

  return [
    includeItem,
    excludeItem,
    cityItem,
    locationTypesItem,
    genderItem,
    ageItem,
    actionInterestItem,
    actionSceneItem,
    actionDaysItem,
    actionIntensityItem,
    actionCatesItem,
    actionWordsItem,
    interestCatesItem,
    interestWordsItem,
    intentionTagsItem,
    brandItem,
    osItem,
    networkTypeItem,
    carrierItem,
    newDeviceItem,
    gamePayLevelItem,
    priceItem,
    appInstallItem,
    autotendItem,
    unOverTargetItem,
    coldStartAudienceItem,
    hideConvertedItem,
    customConvertedItem,
    mobileMediaTypeItem,
    wechatAdActionsItem,
    wechatAdExcludesActionsItem
  ]
}

// 系统定向参数解析
export function convertSystemTarget(target) {
  const params = deepCopy(target)
  // 人群包解析
  const { custom_audience, excluded_custom_audience, cold_start_audience, audience_dict, auto_audience } = params
  let includes, excludes, mult_cold, action_scene, action_days, action_intensity
  const action_tags = []
  const word_tags = []
  if (isArray(custom_audience) && custom_audience.length) {
    includes = custom_audience.map((audience_id) => {
      const audience = audience_dict.filter((dict) => dict.audience_id === audience_id).pop() || {}
      return {
        id: audience.audience_id,
        key: audience.audience_id,
        name: audience.name
      }
    })
  }
  if (isArray(excluded_custom_audience) && excluded_custom_audience.length) {
    excludes = excluded_custom_audience.map((audience_id) => {
      const audience = audience_dict.filter((dict) => dict.audience_id === audience_id).pop() || {}
      return {
        id: audience.audience_id,
        key: audience.audience_id,
        name: audience.name
      }
    })
  }
  if (isArray(cold_start_audience) && cold_start_audience.length) {
    mult_cold = cold_start_audience.map((audience_id) => {
      const audience = audience_dict.filter((dict) => dict.audience_id === audience_id).pop() || {}
      return {
        id: audience.audience_id,
        key: audience.audience_id,
        value: audience.name
      }
    })
  }
  // 行为兴趣解析(behavior是数组)
  const { behavior, interest, intention } = params.behavior_or_interest || {}
  if (isArray(behavior) && behavior.length) {
    const { category_id_tags, keyword_list, scene, time_window, intensity } = behavior[0]
    if (isArray(category_id_tags) && category_id_tags.length) {
      const actions = category_id_tags.map((tag) => {
        return {
          id: tag.id,
          name: tag.name,
          type: 'CATEGORY'
        }
      })
      action_tags.push(...actions)
    }
    if (isArray(keyword_list) && keyword_list.length) {
      const actions = keyword_list.map((tag) => {
        return {
          name: tag,
          type: 'KEYWORD'
        }
      })
      action_tags.push(...actions)
    }
    if (isArray(action_tags) && action_tags.length) {
      action_scene = scene
      action_days = time_window
      action_intensity = intensity
    }
  }
  if (isArray(interest) && interest.length) {
    const { category_id_tags, keyword_list } = interest
    if (isArray(category_id_tags) && category_id_tags.length) {
      const words = category_id_tags.map((tag) => {
        return {
          id: tag.id,
          name: tag.name,
          type: 'CATEGORY'
        }
      })
      action_tags.push(...words)
    }
    if (isArray(keyword_list) && keyword_list.length) {
      const words = keyword_list.map((tag) => {
        return {
          name: tag,
          type: 'KEYWORD'
        }
      })
      action_tags.push(...words)
    }
  }
  if (intention) {
    const { targeting_tags } = intention
    if (!isArray(targeting_tags)) intention.targeting_tags = []
  }
  let interest_action_mode = 'UNLIMITED'
  if (action_tags.length || word_tags.length || (intention && intention.targeting_tags.length)) interest_action_mode = 'CUSTOM'
  if (auto_audience) interest_action_mode = 'RECOMMEND'
  return Object.assign(params, {
    interest_action_mode,
    includes,
    excludes,
    mult_cold,
    action_tags,
    word_tags,
    action_scene,
    action_days,
    action_intensity
  })
}
